{
  "close": "閉じる"
}
